<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="活动名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入活动名称" :maxLength="20" :disabled="form.status === 2"/>
      </a-form-model-item>
      <a-form-model-item label="活动文案" prop="copyText" >
        <a-input v-model="form.copyText" placeholder="请输入活动文案" type="textarea" allow-clear :disabled="form.status === 2"/>
      </a-form-model-item>
      <a-form-model-item label="活动主图" prop="mainImage">
        <oss-multi-upload-single v-model="form.mainImage" type="img" :maxSize="10" :disabled="form.status === 2"></oss-multi-upload-single>
      </a-form-model-item>
      <a-form-model-item label="活动开始时间" prop="startTime">
        <a-date-picker
          style="width: 100%"
          @change="onDateChange"
          v-model="form.startTime"
          :showTime="true"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          :disabled="form.status === 2"
          allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="活动结束时间" prop="endTime">
        <a-date-picker
          style="width: 100%"
          @change="onDateChange1"
          v-model="form.endTime"
          :showTime="true"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          :disabled="form.status === 2"
          allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="领取开始时间" prop="claimStartTime">
        <a-date-picker
          style="width: 100%"
          @change="onDateChange2"
          v-model="form.claimStartTime"
          :showTime="true"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          :disabled="form.status === 2"
          allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="领取结束时间" prop="claimEndTime">
        <a-date-picker
          style="width: 100%"
          @change="onDateChange3"
          v-model="form.claimEndTime"
          :showTime="true"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          :disabled="form.status === 2"
          allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="总奖池金额" prop="totalPool" >
        <a-input-number v-model="form.totalPool" :min="0" :step="1" :precision="0" placeholder="请输入总奖池金额" :disabled="form.status === 2"/>
      </a-form-model-item>
      <a-form-model-item label="剩余奖池金额" prop="remainingPool" >
        <a-input-number v-model="form.remainingPool" :min="0" :step="1" :precision="0" placeholder="请输入剩余奖池金额" :disabled="form.status === 2"/>
      </a-form-model-item>
      <a-form-model-item label="上架状态" prop="putawayStatus">
        <a-select v-model="form.putawayStatus" placeholder="请选择上架状态" allow-clear>
          <a-select-option :value="false">未上架</a-select-option>
          <a-select-option :value="true">已上架</a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>

  </a-drawer>
</template>

<script>
import IndexScriptModal from '@/components/Script/IndexScriptModal.vue'
import OssMultiUpload from '@/views/script/script/modules/OssMultiUpload.vue'
import OssMultiUploadSingle from '@/views/script/script/modules/OssMultiUploadSingle.vue'
import { addRebateActivity, getRebateActivity, updateRebateActivity } from '@/api/played/rebateActivity'

export default {
  name: 'CreateRebateActivity',
  props: {
  },
  components: {
    OssMultiUploadSingle,
    OssMultiUpload,
    IndexScriptModal
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        type: 1,
        name: null,
        copyText: null,
        mainImage: null,
        startTime: null,
        endTime: null,
        claimStartTime: null,
        claimEndTime: null,
        totalPool: null,
        remainingPool: null,
        status: null,
        putawayStatus: undefined
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        copyText: [
          { required: true, message: '请输入活动文案', trigger: 'blur' }
        ],
        mainImage: [
          { required: true, message: '请上传活动主图', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '请选择活动开始时间', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '请选择活动结束时间', trigger: 'blur' }
        ],
        claimStartTime: [
          { required: true, message: '请选择领取开始时间', trigger: 'blur' }
        ],
        claimEndTime: [
          { required: true, message: '请选择领取结束时间', trigger: 'blur' }
        ],
        totalPool: [
          { required: true, message: '请输入总奖池金额', trigger: 'blur' }
        ],
        remainingPool: [
          { required: true, message: '请输入剩余奖池金额', trigger: 'blur' }
        ],
        putawayStatus: [
          { required: true, message: '请选择上架状态', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onDateChange(date, dateString) {
      this.form.startTime = dateString
    },
    onDateChange1(date, dateString) {
      this.form.endTime = dateString
    },
    onDateChange2(date, dateString) {
      this.form.claimStartTime = dateString
    },
    onDateChange3(date, dateString) {
      this.form.claimEndTime = dateString
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: 1,
        name: null,
        copyText: null,
        mainImage: null,
        startTime: null,
        endTime: null,
        claimStartTime: null,
        claimEndTime: null,
        totalPool: null,
        remainingPool: null,
        status: null,
        putawayStatus: undefined
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '新增返现活动'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRebateActivity(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改返现活动'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateRebateActivity(this.form).then(() => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addRebateActivity(this.form).then(() => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
